import React from "react";
import { Link } from "react-router-dom";
import { songs } from "../../../../database/song";
import Layout from "../../../Layout";
import MusicPlayer from "../../../MusicPlayer";

export default function Lib_Podcast() {
  return (
    <>
      <Layout isLibrary={true} />
      <div className="pl-64 pt-20 pb-32 w-screen ">
        {/* <h4 className="text-white text-xl font-semibold">PodCasts</h4> */}
        <div className="flex flex-wrap justify-center items-center">
          <h2 className="text-white text-3xl font-semibold mt-64">
            Coming Soon
          </h2>
          {/* {songs.map((data) => {
            return data.type == "podcast" ? (
              <Link to={`/shows/${data._id}`} key={data._id}>
                <Lib_Card
                  thumbnail={data.singerThumb}
                  artistName={data.singer}
                  type="artist"
                />
              </Link>
            ) : null;
          })} */}
        </div>
      </div>

      {/* <MusicPlayer /> */}
    </>
  );
}
